<template>
  <div class="invoice-index-page invoices main-content">
    <div class="page-header">
      <h3 class="page-title">{{ $t("navigation.po_financing") }}</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="dashboard">
            {{ $t("general.home") }}
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="#">
            {{ $t("navigation.po_financing") }}
          </router-link>
        </li>
      </ol>
      <div class="page-actions row">
        <div class="col-xs-2 mr-4">
          <base-button
            v-show="totalInvoices || filtersApplied"
            :outline="true"
            :icon="filterIcon"
            size="large"
            color="theme"
            right-icon
            @click="toggleFilter"
          >
            {{ $t("general.filter") }}
          </base-button>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div v-show="showFilters" class="filter-section">
        <div class="row">
          <div
            v-if="userType == 'super-admin' || userType == 'supplier'"
            class="col-sm-4"
          >
            <label class="form-label"
              >{{ $tc("customers.customer", 1) }}
            </label>
            <base-customer-select
              ref="customerSelect"
              @select="onSelectCustomer"
              @deselect="clearCustomerSearch"
            />
          </div>
          <div v-if="advanceOption == false" class="col-sm-4">
            <label v-if="userType == 'funder'" class="form-label">{{
              $tc("customers.customer", 1)
            }}</label>
            <label v-else class="form-label">{{
              $t("invoices.supplier", 1)
            }}</label>
            <base-select
              v-model="filters.supplier"
              :options="suppliers"
              :searchable="true"
              :show-labels="false"
              :allow-empty="true"
              :tabindex="8"
              :placeholder="$t('customers.type_or_click')"
              label="company_name"
              track-by="company_id"
            />
          </div>
          <div class="col-sm-4">
            <label>{{ $t("invoices.status") }}</label>
            <base-select
              v-if="userType == 'supplier'"
              v-model="filters.status"
              :options="InvoiceStatuses"
              :group-select="false"
              :searchable="true"
              :show-labels="false"
              :placeholder="$t('general.select_a_status')"
              group-values="options"
              group-label="label"
              track-by="name"
              label="name"
              @remove="clearStatusSearch()"
            />

            <base-select
              v-else-if="userType == 'anchor'"
              v-model="filters.status"
              :options="anchorInvoiceStatuses"
              :group-select="false"
              :searchable="true"
              :show-labels="false"
              :placeholder="$t('general.select_a_status')"
              group-values="options"
              group-label="label"
              track-by="name"
              label="name"
              @remove="clearStatusSearch()"
            />
            <base-select
              v-else
              v-model="filters.status"
              :options="InvoiceStatusesExcludeDraft"
              :group-select="false"
              :searchable="true"
              :show-labels="false"
              :placeholder="$t('general.select_a_status')"
              group-values="options"
              group-label="label"
              track-by="name"
              label="name"
              @remove="clearStatusSearch()"
            />
          </div>
          <div class="col-sm-4">
            <label>{{ $t("invoices.prePayment") }}</label>
            <base-select
              v-if="userType == 'supplier'"
              v-model="filters.request_level"
              :options="InvoicePrepaymentOptions"
              :group-select="false"
              :searchable="true"
              :show-labels="false"
              :placeholder="$t('general.select_a_status')"
              group-values="options"
              group-label="label"
              track-by="name"
              label="name"
              @remove="clearStatusSearch()"
            />
            <base-select
              v-else-if="userType == 'super_admin'"
              v-model="filters.request_level"
              :options="SuperAdminInvoicePrepaymentOptions"
              :group-select="false"
              :searchable="true"
              :show-labels="false"
              :placeholder="$t('general.select_a_status')"
              group-values="options"
              group-label="label"
              track-by="name"
              label="name"
              @remove="clearStatusSearch()"
            />
            <base-select
              v-else-if="userType == 'anchor'"
              v-model="filters.request_level"
              :options="AnchorInvoicePrepaymentOptions"
              :group-select="false"
              :searchable="true"
              :show-labels="false"
              :placeholder="$t('general.select_a_status')"
              group-values="options"
              group-label="label"
              track-by="name"
              label="name"
              @remove="clearRequestLevelSearch()"
            />
            <base-select
              v-else-if="userType == 'funder'"
              v-model="filters.request_level"
              :options="FunderInvoicePrepaymentOptions"
              :group-select="false"
              :searchable="true"
              :show-labels="false"
              :placeholder="$t('general.select_a_status')"
              group-values="options"
              group-label="label"
              track-by="name"
              label="name"
              @remove="clearRequestLevelSearch()"
            />
          </div>
          <div class="col-sm-4">
            <label class="form-label">{{ $t("general.from") }}</label>
            <base-date-picker
              v-model="filters.from_date"
              :calendar-button="true"
              calendar-button-icon="calendar"
            />
          </div>
          <div class="col-sm-4">
            <label class="form-label">{{ $t("general.to") }}</label>
            <base-date-picker
              v-model="filters.to_date"
              :calendar-button="true"
              calendar-button-icon="calendar"
            />
          </div>
          <div class="col-sm-4">
            <label class="form-label">{{
              $t("invoices.invoice_number")
            }}</label>
            <base-input v-model="filters.reference_number" icon="hashtag" />
          </div>
          <div
            v-if="userType == 'supplier' || userType == 'super_admin'"
            class="col-sm-4"
          >
            <label class="form-label">{{
              $t("deliveryNotes.delivery_note_number")
            }}</label>
            <base-input v-model="filters.delivery_note_number" icon="hashtag" />
          </div>
        </div>
        <label class="clear-filter" @click="clearFilter">{{
          $t("general.clear_all")
        }}</label>
      </div>
    </transition>

    <div
      v-cloak
      v-show="showEmptyScreen"
      class="col-xs-1 no-data-info"
      align="center"
    >
      <moon-walker-icon class="mt-5 mb-4" />
      <div class="row" align="center">
        <label class="col title">{{ $t("invoices.no_invoices") }}</label>
      </div>
      <div class="row">
        <label class="description col mt-1" align="center">{{
          $t("invoices.list_of_invoices")
        }}</label>
      </div>
    </div>

    <div v-show="!showEmptyScreen" class="table-container">
      <div class="table-actions mt-5">
        <p class="table-stats">
          {{ $t("general.showing") }}: <b>{{ invoices.length }}</b>
          {{ $t("general.of") }} <b>{{ totalInvoices }}</b>
        </p>

        <!-- Tabs -->
        <ul class="tabs">
          <li class="tab" @click="getStatus('')">
            <a
              :class="[
                'tab-link',
                {
                  'a-active':
                    filters.request_level.value === '' &&
                    (filters.status.value === '' ||
                      filters.status.value === null) &&
                    (filters.funder_receiver === '' ||
                      filters.funder_receiver === null) &&
                    (filters.supplier_receiver === '' ||
                      filters.supplier_receiver === null) &&
                    (filters.settlement === '' ||
                      filters.settlement === null) &&
                    (filters.payment === '' || filters.payment === null) &&
                    (filters.prepayment === '' || filters.prepayment === null)
                }
              ]"
              href="#"
              >{{ $t("general.all") }}
            </a>
          </li>
        </ul>
        <transition name="fade">
          <v-dropdown v-if="showAction" :show-arrow="false">
            <span
              slot="activator"
              href="#"
              class="table-actions-button dropdown-toggle"
            >
              {{ $t("general.actions") }}
            </span>
            <v-dropdown-item v-if="userType === 'anchor'">
              <div class="dropdown-item" @click="makeMultipleInvoicePayment">
                <font-awesome-icon
                  :icon="['fas', 'credit-card']"
                  class="dropdown-item-icon"
                />
                {{ $t("general.make_payment") }}
              </div>
            </v-dropdown-item>
            <v-dropdown-item v-else-if="userType === 'funder'">
              <div
                class="dropdown-item"
                @click="makeMultipleBulkProcess('Pending')"
              >
                {{ $t("general.bulk_pending") }}
              </div>
              <div
                class="dropdown-item"
                @click="makeMultipleBulkProcess('Pre-payment')"
              >
                {{ $t("general.bulk_pre_payment") }}
              </div>
            </v-dropdown-item>

            <v-dropdown-item v-else-if="userType === 'supplier'">
              <v-dropdown-item>
                <div
                  class="dropdown-item"
                  @click="makeMultipleBulkProcess('Eligible')"
                >
                  {{ $t("general.bulk_requested") }}
                </div>
              </v-dropdown-item>
              <v-dropdown-item>
                <div
                  class="dropdown-item"
                  @click="makeMultipleBulkProcess('Financed')"
                >
                  {{ $t("general.financed_approved") }}
                </div>
              </v-dropdown-item>
              <v-dropdown-item>
                <div
                  class="dropdown-item"
                  @click="bulkPrePaymentRequest('Prepaid')"
                >
                  {{ $t("general.bulk_settled") }}
                </div>
              </v-dropdown-item>
            </v-dropdown-item>
            <v-dropdown-item v-else-if="userType === 'super_admin'">
              <div
                class="dropdown-item"
                @click="makeMultipleBulkProcessSuper('Verified')"
              >
                {{ $t("general.bulk_request_to_Verified") }}
              </div>
              <div
                class="dropdown-item"
                @click="makeMultipleBulkProcessSuper('SendToFunder')"
              >
                {{ $t("general.bulk_send_to_funder") }}
              </div>
            </v-dropdown-item>
          </v-dropdown>
        </transition>

        <div v-if="userType == 'funder'" class="col-sm-2">
          <base-select
            v-model="filters.supplier"
            :options="suppliers"
            :searchable="true"
            :show-labels="false"
            :allow-empty="true"
            :tabindex="8"
            :placeholder="$t('customers.type_or_click')"
            label="company_name"
            track-by="company_id"
          />
        </div>
      </div>
      <!-- <div class="custom-control custom-checkbox">
          <input
            id="select-all"
            v-model="selectAllFieldStatus"
            type="checkbox"
            class="custom-control-input"
            @change="selectAllInvoices"
          >
          <label v-show="!isRequestOngoing" for="select-all" class="custom-control-label selectall">
            <span class="select-all-label">{{ $t('general.select_all') }} </span>
          </label>
        </div> -->

      <table-component
        ref="table"
        :show-filter="false"
        :data="fetchData"
        table-class="table"
      >
        <!-- <table-column
            :sortable="false"
            :filterable="false"
            cell-class="no-click"
          >
            <template slot-scope="row">
              <div class="custom-control custom-checkbox">
                <input
                  :id="row.id"
                  v-model="selectField"
                  :value="row.id"
                  type="checkbox"
                  class="custom-control-input"
                >
                <label :for="row.id" class="custom-control-label"/>
              </div>
            </template>
          </table-column> -->
        <table-column
          v-if="userType == 'funder'"
          :label="$t('invoices.financing_request_date')"
          sort-as="prepayment_date"
        >
          <template slot-scope="row">
            <p>{{ row.pre_payment_request.formattedPrePaymentDate }}</p>
          </template>
        </table-column>
        <table-column
          v-else
          :label="$t('invoices.date')"
          sort-as="invoice_date"
          show="formattedInvoiceDate"
        />
        <table-column
          v-if="userType == 'funder'"
          :label="$t('invoices.promised_payment_date')"
          sort-as="promised_date"
        >
          <template slot-scope="row">
            <p>
              {{ row.pre_payment_request.invoice.formattedPromisedPaymentDate }}
            </p>
          </template>
        </table-column>
        <table-column
          v-else
          :label="$t('invoices.due_date')"
          sort-as="due_date"
          show="formattedDueDate"
        />
        <table-column
          v-if="
            userType === 'super_admin' ||
              userType === 'supplier' ||
              userType === 'funder'
          "
          :label="$t('invoices.customer')"
          width="20%"
        >
          <template slot-scope="row">
            <p v-if="row.buyer_stakeholder">
              <span
                v-if="
                  userType == 'supplier' &&
                    row.customer.parent_account_id &&
                    row.buyer_stakeholder.details.company &&
                    row.buyer_stakeholder.details.company.name
                "
              >
                {{ row.buyer_stakeholder.details.company.name }}
              </span>
              <span
                v-else-if="
                  userType == 'supplier' &&
                    row.customer.parent_account_id == null
                "
              >
                {{ row.buyer_stakeholder.details.user.name }}
              </span>
              <!-- {{row.buyer_stakeholder.details.user.name}} -->
              <span v-else>
                {{ row.buyer_stakeholder.details.company.name }}
              </span>
            </p>
          </template>
        </table-column>

        <table-column
          v-if="
            userType === 'super_admin' ||
              userType === 'anchor' ||
              userType === 'funder'
          "
          :label="$t('invoices.supplier')"
        >
          <template slot-scope="row">
            <p v-if="row.supplier_stakeholder">
              <span
                v-if="
                  row.supplier_stakeholder.details.company &&
                    row.supplier_stakeholder.details.company.name
                "
              >
                {{ row.supplier_stakeholder.details.company.name }}
              </span>
              <!-- {{row.supplier_stakeholder.details.user.name}} -->
            </p>
          </template>
        </table-column>
        <table-column
          v-if="userType != 'super_admin'"
          :label="$t('invoices.status')"
          sort-as="status"
        >
          <template v-if="row.overall_status" slot-scope="row">
            <span> {{ $t("invoices.status") }}</span>
            <span
              v-if="userType == 'anchor' && row.overall_status == 'SENT'"
              :class="'inv-status-' + row.overall_status.toLowerCase()"
              >{{ $t("general.received").toUpperCase() }}</span
            >
            <span
              v-else-if="userType == 'anchor' && row.overall_status != 'SENT'"
              :class="'inv-status-' + row.overall_status.toLowerCase()"
              >{{
                row.overall_status != "PARTIALLY_PAID"
                  ? row.overall_status
                  : row.overall_status.replace("_", " ")
              }}</span
            >
            <span
              v-else-if="userType != 'anchor'"
              :class="'inv-status-' + row.overall_status.toLowerCase()"
              >{{
                row.overall_status != "PARTIALLY_PAID"
                  ? row.overall_status
                  : row.overall_status.replace("_", " ")
              }}</span
            >
          </template>
        </table-column>

        <!-- <table-column
            :label="$t('invoices.invoice_num')"
            show="reference_number"
          /> -->

        <table-column :label="$t('pos.ref_num')" show="reference_number" />

        <table-column :label="$t('invoices.amount')" sort-as="total">
          <template slot-scope="row">
            <span>{{ $t("invoices.amount") }}</span>
            <div
              v-html="
                $utils.formatMoney(row.nominal_amount, row.customer.currency)
              "
            />
          </template>
        </table-column>
        <table-column
          :label="$t('invoices.prePayment')"
          sort-as="request_level"
        >
          <template slot-scope="row">
            <span> {{ $t("invoices.prePayment") }}</span>
            <span
              v-if="row.request_level == 'Pending' && row.funder_invoices.user"
              :class="'inv-status-' + row.request_level.toLowerCase()"
            >
              {{ row.request_level }}-{{ row.funder_invoices.user.name }}</span
            >
            <span
              v-else-if="row.request_level == 'Financed'"
              :class="'inv-status-' + row.request_level.toLowerCase()"
              >{{ $t("general.financing_approved") }}</span
            >
            <span
              v-else
              :class="'inv-status-' + row.request_level.toLowerCase()"
            >
              {{ row.request_level }}</span
            >
          </template>
        </table-column>
        <table-column
          :sortable="false"
          :filterable="false"
          cell-class="action-dropdown no-click"
        >
          <template slot-scope="row">
            <span>{{ $t("invoices.action") }}</span>
            <v-dropdown>
              <a slot="activator" href="#">
                <dot-icon />
              </a>
              <v-dropdown-item>
                <router-link
                  v-if="
                    userType === 'supplier' ||
                      userType === 'anchor' ||
                      userType === 'super_admin'
                  "
                  :to="{ path: `preapproved-invoices/${row.id}/attachment` }"
                  class="dropdown-item"
                >
                  <font-awesome-icon icon="file" class="dropdown-item-icon" />
                  {{ $t("invoices.attachments") }}
                </router-link>
              </v-dropdown-item>
              <!-- open prepayment verified  -->
              <v-dropdown-item
                v-if="
                  userType == 'super_admin' &&
                    row.pre_pay == 1 &&
                    row.request_level == 'Requested'
                "
              >
                <a
                  class="dropdown-item"
                  href="#/"
                  @click="openPrepaymentVerified(row.id)"
                >
                  <font-awesome-icon
                    :icon="['far', 'comment']"
                    class="dropdown-item-icon"
                  />
                  {{ $t("invoices.review_prePayment_request") }}
                </a>
              </v-dropdown-item>
              <v-dropdown-item
                v-if="
                  userType == 'super_admin' &&
                    row.pre_pay == 1 &&
                    (row.request_level == 'Verified' ||
                      row.request_level == 'Approved' ||
                      row.request_level == 'Pending')
                "
              >
                <a
                  class="dropdown-item"
                  href="#/"
                  @click="reviewPrepaymentRequest(row.id)"
                >
                  <font-awesome-icon
                    :icon="['far', 'comment']"
                    class="dropdown-item-icon"
                  />
                  {{ $t("invoices.review_prePayment_request") }}
                </a>
              </v-dropdown-item>

              <v-dropdown-item
                v-if="
                  userType == 'anchor' &&
                    row.pre_pay === 1 &&
                    (row.request_level === 'Verified' ||
                      row.request_level === 'Pending')
                "
              >
                <a
                  class="dropdown-item"
                  href="#/"
                  @click="reviewPrepaymentRequest(row.id)"
                >
                  <font-awesome-icon
                    :icon="['far', 'comment']"
                    class="dropdown-item-icon"
                  />
                  {{ $t("invoices.review_prePayment_request") }}
                </a>
              </v-dropdown-item>
              <!-- open prepayment funder  -->
              <v-dropdown-item
                v-if="
                  userType == 'funder' &&
                    row.pre_pay == 1 &&
                    row.request_level == 'Pending'
                "
              >
                <a
                  class="dropdown-item"
                  href="#/"
                  @click="openPrepaymentPending(row.id)"
                >
                  <font-awesome-icon
                    :icon="['far', 'comment']"
                    class="dropdown-item-icon"
                  />
                  {{ $t("invoices.review_prePayment_request") }}
                </a>
              </v-dropdown-item>

              <v-dropdown-item
                v-if="
                  userType == 'supplier' &&
                    row.pre_pay == 1 &&
                    (row.request_level == 'Requested' ||
                      row.request_level == 'Verified' ||
                      row.request_level == 'Approved' ||
                      row.request_level == 'Pending' ||
                      row.request_level == 'Finance' ||
                      row.request_level == 'Prepaid' ||
                      row.request_level == 'Settled' ||
                      row.request_level == 'Offer Expired')
                "
              >
                <a
                  class="dropdown-item"
                  href="#/"
                  @click="reviewPrepaymentRequest(row.id)"
                >
                  <font-awesome-icon
                    :icon="['far', 'comment']"
                    class="dropdown-item-icon"
                  />
                  {{ $t("invoices.review_prePayment_request") }}
                </a>
              </v-dropdown-item>

              <!---->
              <v-dropdown-item
                v-if="
                  userType == 'super_admin' &&
                    row.pre_pay == 1 &&
                    (row.request_level == 'Offered' ||
                      row.request_level == 'Financed')
                "
              >
                <a href="#/" class="dropdown-item" @click="viewOffer(row.id)">
                  <font-awesome-icon
                    :icon="['far', 'comment']"
                    class="dropdown-item-icon"
                  />
                  {{ $t("invoices.view_offer") }}
                </a>
              </v-dropdown-item>

              <v-dropdown-item
                v-if="
                  (userType == 'supplier' || userType == 'funder') &&
                    row.pre_pay == 1 &&
                    row.funder_invoices &&
                    (row.request_level == 'Offered' ||
                      row.request_level == 'Financed' ||
                      row.request_level == 'Rejected')
                "
              >
                <a href="#/" class="dropdown-item" @click="viewOffer(row.id)">
                  <font-awesome-icon
                    :icon="['far', 'comment']"
                    class="dropdown-item-icon"
                  />
                  {{ $t("invoices.view_offer") }}
                </a>
              </v-dropdown-item>

              <v-dropdown-item
                v-if="
                  (userType == 'supplier' &&
                    row.request_level === 'Eligible') ||
                    row.request_level === 'Rejected'
                "
              >
                <a
                  class="dropdown-item"
                  href="#/"
                  @click="showPrePaymentRequestPopup(row.id, row)"
                >
                  <font-awesome-icon
                    :icon="['far', 'question-circle']"
                    class="dropdown-item-icon"
                  />
                  {{ getPopupText(row) }}
                </a>
              </v-dropdown-item>

              <v-dropdown-item
                v-if="
                  userType == 'super_admin' && row.request_level == 'Verified'
                "
              >
                <router-link
                  :to="`/super-admin/preappoved-invoice/${row.id}/funder`"
                  class="dropdown-item"
                >
                  <font-awesome-icon
                    icon="paper-plane"
                    class="dropdown-item-icon"
                  />
                  {{ $t("invoices.sendToFunder") }}
                </router-link>
              </v-dropdown-item>
              <v-dropdown-item
                v-if="
                  userType == 'funder' &&
                    (row.request_level != 'Settled' &&
                      row.request_level != 'BLOCKED')
                "
              >
                <a
                  v-if="
                    userType == 'funder' &&
                      row.request_level == 'Financed' &&
                      row.prepayment == null
                  "
                  class="dropdown-item"
                  href="#/"
                  @click="makePrepayment(row.id)"
                >
                  <font-awesome-icon
                    :icon="['fas', 'check']"
                    class="dropdown-item-icon"
                  />
                  {{ $t("invoices.make_prepayment") }}
                </a>
              </v-dropdown-item>

              <!--anchor pay case: when request status: Eligible, Rejected, Prepaid-->

              <v-dropdown-item>
                <a
                  v-if="
                    userType === 'supplier' &&
                      row.request_level == 'Prepaid' &&
                      row.pre_pay == 1 &&
                      row.status != 'DRAFT'
                  "
                  class="dropdown-item"
                  href="#/"
                  @click="needSettlement(row.id)"
                >
                  <font-awesome-icon
                    :icon="['fas', 'handshake']"
                    class="dropdown-item-icon"
                  />
                  {{ $t("general.need_settlement") }}
                </a>
              </v-dropdown-item>
              <v-dropdown-item>
                <router-link
                  v-if="
                    row.request_level == 'Prepaid' ||
                      row.request_level == 'Settled'
                  "
                  :to="{ path: `payments/${row.id}/record` }"
                  class="dropdown-item"
                >
                  <font-awesome-icon
                    :icon="['fas', 'history']"
                    class="dropdown-item-icon"
                  />
                  {{ $t("general.payment_record") }}
                </router-link>
              </v-dropdown-item>
              <v-dropdown-item>
                <router-link
                  :to="{ path: `purchaseorder-financing/${row.id}/record` }"
                  class="dropdown-item"
                >
                  <font-awesome-icon
                    :icon="['fas', 'history']"
                    class="dropdown-item-icon"
                  />
                  {{ $t("general.action_record") }}
                </router-link>
              </v-dropdown-item>
              <v-dropdown-item
                v-if="
                  row.request_level == 'Eligible' &&
                    (userType === 'anchor' || userType === 'super_admin')
                "
              >
                <div class="dropdown-item" @click="removeInvoice(row.id)">
                  <font-awesome-icon
                    :icon="['fas', 'trash']"
                    class="dropdown-item-icon"
                  />
                  {{ $t("general.delete") }}
                </div>
              </v-dropdown-item>
              <v-dropdown-item
                v-if="userType === 'super_admin' && row.status != 'BLOCKED'"
              >
                <a
                  class="dropdown-item"
                  href="#/"
                  @click="blockedInvoicefunction(row.id)"
                >
                  <font-awesome-icon
                    :icon="['fas', 'ban']"
                    class="dropdown-item-icon"
                  />
                  {{ $t("general.blocked") }}
                </a>
              </v-dropdown-item>

              <v-dropdown-item
                v-if="userType === 'super_admin' && row.status === 'BLOCKED'"
              >
                <a
                  class="dropdown-item"
                  href="#/"
                  @click="unblockedInvoicefunction(row.id)"
                >
                  <font-awesome-icon
                    :icon="['fas', 'unlock']"
                    class="dropdown-item-icon"
                  />
                  {{ $t("general.unblocked") }}
                </a>
              </v-dropdown-item>
            </v-dropdown>
          </template>
        </table-column>
      </table-component>
    </div>
    <base-loader v-if="searchingVal" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MoonWalkerIcon from "../../../js/components/icon/MoonwalkerIcon";
import moment from "moment";

export default {
  components: {
    "moon-walker-icon": MoonWalkerIcon
  },
  data() {
    return {
      request_level: null,
      suppliers: [],
      userType: "",
      process_title: "",
      advanceOption: true,
      showFilters: false,
      currency: null,
      InvoiceStatuses: [
        {
          label: "Status",
          isDisable: true,
          options: [
            { name: "DRAFT", value: "DRAFT" },
            { name: "SENT", value: "SENT" },
            { name: "AUTHORIZED", value: "AUTHORIZED" }
          ]
        },
        {
          label: "Paid Status",
          options: [
            { name: "UNPAID", value: "UNPAID" },
            { name: "PAID", value: "PAID" },
            { name: "PARTIALLY PAID", value: "PARTIALLY_PAID" }
          ]
        }
      ],
      anchorInvoiceStatuses: [
        {
          label: "Status",
          isDisable: true,
          options: [
            { name: "RECEIVED", value: "SENT" },
            { name: "AUTHORIZED", value: "AUTHORIZED" }
          ]
        },
        {
          label: "Paid Status",
          options: [
            { name: "UNPAID", value: "UNPAID" },
            { name: "PAID", value: "PAID" },
            { name: "PARTIALLY PAID", value: "PARTIALLY_PAID" }
          ]
        }
      ],
      InvoiceStatusesExcludeDraft: [
        {
          label: "Status",
          isDisable: true,
          options: [{ name: "SENT", value: "SENT" }]
        },
        {
          label: "Paid Status",
          options: [
            { name: "UNPAID", value: "UNPAID" },
            { name: "PAID", value: "PAID" },
            { name: "PARTIALLY PAID", value: "PARTIALLY_PAID" }
          ]
        }
      ],
      InvoicePrepaymentOptions: [
        {
          label: "Pre-payment",
          isDisable: true,
          options: [
            { name: "Eligible", value: "Eligible" },
            { name: "Not Eligible", value: "Not Eligible" },
            { name: "Requested", value: "Requested" },
            { name: "Verified", value: "Verified" },
            { name: "Approved", value: "Approved" },
            { name: "Pending", value: "Pending" },
            { name: "Offered", value: "Offered" },
            { name: "Financed", value: "Financed" },
            { name: "Prepaid", value: "Prepaid" },
            { name: "Settled", value: "Settled" },
            { name: "Rejected", value: "Rejected" }
          ]
        }
      ],
      SuperAdminInvoicePrepaymentOptions: [
        {
          label: "Pre-payment",
          isDisable: true,
          options: [
            { name: "Requested", value: "Requested" },
            { name: "Verified", value: "Verified" },
            { name: "Approved", value: "Approved" },
            { name: "Pending", value: "Pending" },
            { name: "Offered", value: "Offered" },
            { name: "Financed", value: "Financed" },
            { name: "Prepaid", value: "Prepaid" },
            { name: "Settled", value: "Settled" },
            { name: "Rejected", value: "Rejected" },
            { name: "Offer Expired", value: "Offer Expired" }
          ]
        }
      ],

      AnchorInvoicePrepaymentOptions: [
        {
          label: "Pre-payment",
          isDisable: true,
          options: [
            { name: "Requested", value: "Verified" },
            { name: "Approved", value: "Approved" },
            { name: "Pending", value: "Pending" },
            { name: "Offered", value: "Offered" },
            { name: "Financing Approved", value: "Financed" },
            { name: "Prepaid", value: "Prepaid" },
            { name: "Settled", value: "Settled" },
            { name: "Rejected", value: "Rejected" }
          ]
        }
      ],

      FunderInvoicePrepaymentOptions: [
        {
          label: "Pre-payment",
          isDisable: true,
          options: [
            { name: "Requested", value: "Pending" },
            { name: "Offered", value: "Offered" },
            { name: "Financed", value: "Financed" },
            { name: "Prepaid", value: "Prepaid" },
            { name: "Settled", value: "Settled" },
            { name: "Rejected", value: "Rejected" }
          ]
        }
      ],

      filtersApplied: false,
      isRequestOngoing: true,
      filters: {
        request_level: { name: "", value: "" },
        supplier: "",
        customer: "",
        status: { name: "", value: "" },
        from_date: "",
        to_date: "",
        reference_number: "",
        delivery_note_number: "",
        funder_receiver: "",
        supplier_receiver: "",
        settlement: "",
        payment: "",
        prepayment: "",
        type: "preapproved"
      }
    };
  },

  computed: {
    ...mapGetters("currency", ["defaultCurrency"]),
    showEmptyScreen() {
      return (
        !this.totalInvoices && !this.isRequestOngoing && !this.filtersApplied
      );
    },
    filterIcon() {
      return this.showFilters ? "times" : "filter";
    },
    ...mapGetters("customer", ["customers"]),
    ...mapGetters("modal", ["searchingVal"]),
    ...mapGetters("invoice", [
      "selectedInvoices",
      "totalInvoices",
      "invoices",
      "selectAllField"
    ]),
    ...mapGetters("po", ["POForInvoices"]),
    showPOinvoiceTitle() {
      if (this.userType === "supplier" && this.POForInvoices) {
        return true;
      } else {
        return false;
      }
    },
    showAction() {
      const uniqueIds = new Set(this.selectedInvoices.map(item => item));
      // console.log(this.invoices.find(item => ['PAID', 'PARTIALLY_PAID'].includes(item.overall_status) && uniqueIds.has(item.id)))
      return (
        !this.invoices.find(
          item =>
            ["PAID", "PARTIALLY_PAID"].includes(item.overall_status) &&
            item.request_level === "Eligible" &&
            uniqueIds.has(item.id)
        ) && uniqueIds.size
      );
    },
    statusOptions: {
      get: function() {
        return this.selectedInvoices;
      },
      set: function(val) {
        this.selectInvoice(val);
      }
    },
    selectField: {
      get: function() {
        return this.selectedInvoices;
      },
      set: function(val) {
        this.selectInvoice(val);
      }
    },
    selectAllFieldStatus: {
      get: function() {
        return this.selectAllField;
      },
      set: function(val) {
        this.setSelectAllState(val);
      }
    }
  },
  watch: {
    filters: {
      handler: "setFilters",
      deep: true
    }
  },
  created() {
    if (
      localStorage.getItem("account_type") === "funder" ||
      localStorage.getItem("role") === "super_admin" ||
      localStorage.getItem("account_type") === "anchor"
    ) {
      this.advanceOption = false;
    } else {
      this.advanceOption = true;
    }

    if (localStorage.getItem("role") === "super_admin") {
      this.userType = "super_admin";
      this.getSuppliers();
      this.fetchCustomers();
    } else if (localStorage.getItem("account_type") === "anchor") {
      this.userType = "anchor";
      this.getSuppliers();
    } else if (localStorage.getItem("account_type") === "funder") {
      this.userType = "funder";
      this.getClients();
    } else if (localStorage.getItem("account_type") === "supplier") {
      this.userType = "supplier";
      this.fetchCustomers();
    }
  },
  destroyed() {
    if (this.selectAllField) {
      this.selectAllInvoices();
    }
    if (this.POForInvoices) {
      this.resetPOForInvoices();
    }
  },
  methods: {
    ...mapActions("modal", ["openModal", "setIsSearching"]),
    ...mapActions("preapprovedinvoice", ["selectedSupplier"]),
    ...mapActions("invoice", [
      "fetchAllInvoices",
      "fetchInvoices",
      "getRecord",
      "selectInvoice",
      "resetSelectedInvoices",
      "selectAllInvoices",
      "deleteInvoice",
      "paymentMultipleInvoices",
      "sendEmail",
      "markAsSent",
      "setSelectAllState",
      "cloneInvoice",
      "FetchInvoiceSuppliers",
      "funderInvoices",
      "rejectedInvoice",
      "blockedInvoice",
      "unblockedInvoice",
      "bulkProcessRequestedInvoicesWithData",
      "bulkProcessPrePaymentInvoices"
    ]),
    ...mapActions("customer", ["fetchCustomers"]),
    ...mapActions("LoanRequest", ["loanRequestStatus"]),
    ...mapActions("po", ["resetPOForInvoices"]),
    ...mapActions("supplier", ["fetchSuppliers"]),
    async loadInvoices() {
      await this.resetPOForInvoices();
      this.refreshTable();
    },
    async bulkPrePaymentRequest() {
      this.openModal({
        title: "Bulk Settlement",
        componentName: "BulkSettleProcessingModal"
      });
    },

    dueDateCheck(dueDate) {
      const expireDate = moment(dueDate).startOf("day");
      const currentDate = moment().startOf("day");
      return expireDate.isSameOrAfter(currentDate);
    },

    async getClients() {
      let response = await this.fetchCustomers({
        role: "admin",
        pagination: "no"
      });
      this.suppliers = response.data.customers.data;
    },
    async getSuppliers() {
      let response;
      if (this.userType === "super_admin") {
        response = await this.fetchSuppliers({
          role: "admin",
          pagination: "no",
          account_type: "supplier"
        });
      } else {
        response = await this.fetchSuppliers({
          role: "admin",
          pagination: "no"
        });
      }

      this.suppliers = response.data.suppliers.data;
    },
    async InvoiceSuppliers() {
      let invoiceSuppliers = await this.FetchInvoiceSuppliers();
      this.suppliers = invoiceSuppliers.data.suppliers;
    },
    async makePrepayment(id) {
      this.$router.push(`/funder/payments/${id}/prepayment/create`);
    },
    async viewPrepayment(id) {
      if (this.userType === "super_admin") {
        this.$router.push(`/super-admin/prepayments/${id}/view`);
      } else if (this.userType === "anchor") {
        this.$router.push(`/anchor/prepayments/${id}/view`);
      } else if (this.userType === "supplier") {
        this.$router.push(`/supplier/prepayments/${id}/view`);
      } else if (this.userType === "funder") {
        this.$router.push(`/funder/prepayments/${id}/view`);
      }
    },
    needSettlement(id) {
      if (this.userType === "supplier") {
        this.$router.push(`/supplier/payments/${id}/settlement/create`);
      } else if (this.userType === "funder") {
        this.$router.push(`/funder/payments/${id}/settlement/create`);
      }
    },
    async prepaymentRequest(id) {
      this.$router.push(
        `/supplier/preapproved-invoice/prepayments/${id}/request`
      );
    },
    async verifiedPrepaymentRequest(id) {
      const data = {
        invoice_id: id,
        request_level: "Verified"
      };
      let response = await this.loanRequestStatus(data);
      this.refreshTable();
      if (response.data.success) {
        window.toastr["success"](
          this.$tc("invoices.verified_prepayment_successfully")
        );
        return true;
      }
    },
    async approvedPrepaymentRequest(id) {
      const data = {
        invoice_id: id,
        request_level: "Approved"
      };
      let response = await this.loanRequestStatus(data);
      this.refreshTable();
      if (response.data.success) {
        window.toastr["success"](
          this.$tc("invoices.approved_prepayment_successfully")
        );
        return true;
      }
    },
    async offeredPrepaymentRequest(id) {
      const data = {
        invoice_id: id,
        request_level: "Offered"
      };
      let response = await this.loanRequestStatus(data);
      this.refreshTable();
      if (response.data.success) {
        window.toastr["success"](
          this.$tc("invoices.offer_prepayment_successfully")
        );
        this.$router.push(`/funder/prepayments/${id}/offer`);
        return true;
      }
    },
    async rejectedPrepaymentRequest(id) {
      const data = {
        invoice_id: id,
        request_level: "Rejected"
      };
      let response = await this.loanRequestStatus(data);
      this.refreshTable();
      if (response.data.success) {
        window.toastr["success"](
          this.$tc("invoices.rejected_prepayment_successfully")
        );
        return true;
      }
    },
    async openPrepaymentVerified(id) {
      this.$router.push(`/super-admin/preapproved/prepayments/${id}/verified`);
    },
    async openPrepaymentApproved(id) {
      this.$router.push(`/anchor/prepayments/${id}/approved`);
    },
    async openPrepaymentPending(id) {
      this.$router.push(`/funder/purchaseorder-financing/${id}/pending`);
    },
    async reviewPrepaymentRequest(id) {
      if (this.userType === "super_admin") {
        this.$router.push(`/super-admin/preapproved/prepayments/${id}/view`);
      } else if (this.userType === "anchor") {
        this.$router.push(`/anchor/preapproved/prepayments/${id}/view`);
      } else if (this.userType === "supplier") {
        this.$router.push(`/supplier/preapproved/prepayments/${id}/view`);
      } else if (this.userType === "funder") {
        this.$router.push(`/funder/preapproved/prepayments/${id}/view`);
      }
    },
    async viewOffer(id) {
      if (this.userType === "super_admin") {
        this.$router.push(`/super-admin/preapproved/prepayments/${id}/offer`);
      } else if (this.userType === "anchor") {
        this.$router.push(`/anchor/preapproved/prepayments/${id}/offer`);
      } else if (this.userType === "supplier") {
        this.$router.push(`/supplier/preapproved/prepayments/${id}/offer`);
      } else if (this.userType === "funder") {
        this.$router.push(`/funder/purchaseorder-financing/${id}/offer`);
      }
    },
    async sendInvoice(row) {
      if (row.attachments.length > 0) {
        swal({
          title: this.$t("general.are_you_sure"),
          text: this.$t("invoices.confirm_send"),
          icon: "/assets/icon/paper-plane-solid.svg",
          buttons: true,
          dangerMode: true
        }).then(async value => {
          if (value) {
            const data = {
              invoice_id: row.id
            };
            let response = await this.sendEmail(data);
            this.refreshTable();
            if (response.data.success) {
              window.toastr["success"](
                this.$tc("invoices.send_invoice_successfully")
              );
              if (row.pre_pay == 1) {
                this.showPrePaymentRequestPopup(row.id);
              }
              return true;
            }
            if (response.data.error === "user_email_does_not_exist") {
              window.toastr["error"](
                this.$tc("invoices.user_email_does_not_exist")
              );
              return false;
            }
            window.toastr["error"](this.$tc("invoices.something_went_wrong"));
          }
        });
      } else {
        swal({
          title: this.$t("general.attach_documents"),
          text: this.$t("invoices.without_attachments_you_cant_sent"),
          icon: "/assets/icon/file-alt-solid.svg",
          dangerMode: true,
          buttons: {
            buttonOne: {
              text: "Continue Anyway",
              value: "continue_anyway",
              visible: true,
              className: "swal-button--cancel",
              closeModal: true
            },
            buttonTwo: {
              text: "Go to Attachments",
              value: "go_to_attachments",
              visible: true,
              className: "swal-button--danger",
              closeModal: true
            }
          }
        }).then(async goToAttachment => {
          if (goToAttachment === "go_to_attachments") {
            this.$router.push(`/supplier/invoices/${row.id}/attachment`);
          } else if (goToAttachment === "continue_anyway") {
            const data = {
              invoice_id: row.id
            };
            let response = await this.sendEmail(data);
            this.refreshTable();
            if (response.data.success) {
              window.toastr["success"](
                this.$tc("invoices.send_invoice_successfully")
              );
              if (row.pre_pay === 1) {
                this.showPrePaymentRequestPopup(row.id);
              }
              return true;
            }
            if (response.data.error === "user_email_does_not_exist") {
              window.toastr["error"](
                this.$tc("invoices.user_email_does_not_exist")
              );
              return false;
            }
            window.toastr["error"](this.$tc("invoices.something_went_wrong"));
          }
        });
      }
    },
    async showPrePaymentRequestPopup(id, row) {
      if (row.request_level === "Offer Expired") {
        swal({
          title: this.$t("invoices.request_apply_for_PrePayment"),
          text: this.$t("invoices.offer_expired_try_again_tomorrow"),
          icon: "warning",
          buttons: false,
          timer: 3000
        });
        return;
      }

      // If eligible, show the confirmation popup
      swal({
        title: this.$t("invoices.request_apply_for_PrePayment"),
        text: this.$t("invoices.do_you_want_to_apply_for_prepayment_request"),
        icon: "/assets/icon/check-circle-solid.svg",
        buttons: true,
        dangerMode: true
      }).then(async value => {
        if (value) {
          this.prepaymentRequest(id);
        }
      });
    },

    getPopupText(row) {
      return this.$t("invoices.request_apply_for_PrePayment");
    },

    async onCloneInvoice(id) {
      swal({
        title: this.$t("general.are_you_sure"),
        text: this.$t("invoices.confirm_clone"),
        icon: "/assets/icon/check-circle-solid.svg",
        buttons: true,
        dangerMode: true
      }).then(async value => {
        if (value) {
          const data = {
            invoice_id: id
          };
          let response = await this.cloneInvoice(data);
          this.refreshTable();
          if (response.data) {
            window.toastr["success"](this.$tc("invoices.cloned_successfully"));
            this.$router.push(
              `/supplier/invoices/${response.data.invoice.id}/edit`
            );
          }
        }
      });
    },
    getPrepayment(val) {
      this.filters.prepayment = val;
      this.filters.payment = "";
      this.filters.settlement = "";
      this.filters.supplier_receiver = "";
      this.filters.funder_receiver = "";
      this.filters.request_level = {
        name: "",
        value: ""
      };
      this.filters.status = {
        name: "",
        value: ""
      };
    },
    getPayment(val) {
      this.filters.payment = val;
      this.filters.prepayment = "";
      this.filters.settlement = "";
      this.filters.supplier_receiver = "";
      this.filters.funder_receiver = "";
      this.filters.request_level = {
        name: "",
        value: ""
      };
      this.filters.status = {
        name: "",
        value: ""
      };
    },
    getSettlement(val) {
      this.filters.payment = "";
      this.filters.prepayment = "";
      this.filters.settlement = val;
      this.filters.supplier_receiver = "";
      this.filters.funder_receiver = "";
      this.filters.request_level = {
        name: "",
        value: ""
      };
      this.filters.status = {
        name: "",
        value: ""
      };
    },
    getSupplierReceiver(val) {
      this.filters.supplier_receiver = val;
      this.filters.settlement = "";
      this.filters.payment = "";
      this.filters.prepayment = "";
      this.filters.funder_receiver = "";
      this.filters.request_level = {
        name: "",
        value: ""
      };
      this.filters.status = {
        name: "",
        value: ""
      };
    },
    getFunderReceiver(val) {
      this.filters.funder_receiver = val;
      this.filters.settlement = "";
      this.filters.supplier_receiver = "";
      this.filters.payment = "";
      this.filters.prepayment = "";
      this.filters.request_level = {
        name: "",
        value: ""
      };
      this.filters.status = {
        name: "",
        value: ""
      };
    },
    getStatus(val) {
      this.filters.supplier_receiver = "";
      this.filters.settlement = "";
      this.filters.payment = "";
      this.filters.prepayment = "";
      this.filters.funder_receiver = "";
      this.filters.request_level = {
        name: "",
        value: ""
      };
      this.filters.status = {
        name: val,
        value: val
      };
    },
    getLoanRequest(name, val) {
      this.filters.settlement = "";
      this.filters.payment = "";
      this.filters.prepayment = "";
      this.filters.supplier_receiver = "";
      this.filters.funder_receiver = "";
      this.filters.status = {
        name: "",
        value: ""
      };
      this.filters.request_level = {
        name: name,
        value: val
      };
    },
    refreshTable(val) {
      this.$refs.table.refresh();
    },
    async fetchData({ page, filter, sort }) {
      let data = {
        type: this.filters.type,
        customer_id:
          this.filters.customer === ""
            ? this.filters.customer
            : this.filters.customer.id,
        status: this.filters.status.value,
        request_level: this.filters.request_level.value,
        funder_receiver: this.filters.funder_receiver,
        settlement: this.filters.settlement,
        payment: this.filters.payment,

        from_date:
          this.filters.from_date === ""
            ? this.filters.from_date
            : moment(this.filters.from_date).format("DD/MM/YYYY"),
        to_date:
          this.filters.to_date === ""
            ? this.filters.to_date
            : moment(this.filters.to_date).format("DD/MM/YYYY"),
        reference_number: this.filters.reference_number,
        delivery_note_number: this.filters.delivery_note_number,
        orderByField: sort.fieldName || "invoice_number",
        orderBy: sort.order || "desc",
        page
      };
      let anchorData = {
        type: this.filters.type,
        status: this.filters.status.value,
        request_level: this.filters.request_level.value,
        funder_receiver: this.filters.funder_receiver,
        settlement: this.filters.settlement,
        payment: this.filters.payment,
        company_id:
          this.filters.supplier === ""
            ? this.filters.supplier
            : this.filters.supplier.company_id,
        from_date:
          this.filters.from_date === ""
            ? this.filters.from_date
            : moment(this.filters.from_date).format("DD/MM/YYYY"),
        to_date:
          this.filters.to_date === ""
            ? this.filters.to_date
            : moment(this.filters.to_date).format("DD/MM/YYYY"),
        reference_number: this.filters.reference_number,
        delivery_note_number: this.filters.delivery_note_number,
        orderByField: sort.fieldName || "invoice_number",
        orderBy: sort.order || "desc",
        page
      };
      if (this.POForInvoices) {
        data.purchase_order_id = this.POForInvoices;
        anchorData.purchase_order_id = this.POForInvoices;
      }
      let adminData = {
        type: this.filters.type,
        pre_pay: "1",
        user_id:
          this.filters.supplier === ""
            ? this.filters.supplier
            : this.filters.supplier.id,
        customer_id:
          this.filters.customer === ""
            ? this.filters.customer
            : this.filters.customer.id,
        status: this.filters.status.value,
        request_level: this.filters.request_level.value,

        from_date:
          this.filters.from_date === ""
            ? this.filters.from_date
            : moment(this.filters.from_date).format("DD/MM/YYYY"),
        to_date:
          this.filters.to_date === ""
            ? this.filters.to_date
            : moment(this.filters.to_date).format("DD/MM/YYYY"),
        reference_number: this.filters.reference_number,
        delivery_note_number: this.filters.delivery_note_number,
        orderByField: sort.fieldName || "invoice_number",
        orderBy: sort.order || "desc",
        page
      };
      let funderData = {
        type: this.filters.type,
        pre_pay: "1",
        company_id:
          this.filters.supplier === ""
            ? this.filters.supplier
            : this.filters.supplier.company_id,
        status: this.filters.status.value,

        request_level: this.filters.request_level.value,
        supplier_receiver: this.filters.supplier_receiver,
        settlement: this.filters.settlement,
        prepayment: this.filters.prepayment,
        from_date:
          this.filters.from_date === ""
            ? this.filters.from_date
            : moment(this.filters.from_date).format("DD/MM/YYYY"),
        to_date:
          this.filters.to_date === ""
            ? this.filters.to_date
            : moment(this.filters.to_date).format("DD/MM/YYYY"),
        reference_number: this.filters.reference_number,
        orderByField: sort.fieldName || "invoice_number",
        orderBy: sort.order || "desc",
        page
      };
      this.selectedSupplier(funderData.company_id);
      this.isRequestOngoing = true;
      let response;
      if (this.userType === "super_admin") {
        response = await this.fetchInvoices(adminData);
      } else if (this.userType === "funder") {
        response = await this.fetchInvoices(funderData);
      } else if (this.userType === "anchor") {
        response = await this.fetchInvoices(anchorData);
      } else {
        response = await this.fetchInvoices(data);
      }
      this.isRequestOngoing = false;
      this.currency = response.data.currency;
      return {
        data: response.data.invoices.data,
        pagination: {
          totalPages: response.data.invoices.last_page,
          currentPage: page,
          count: response.data.invoices.count
        }
      };
    },
    setFilters() {
      this.filtersApplied = true;
      this.resetSelectedInvoices();
      this.refreshTable();
    },
    clearFilter() {
      if (this.filters.customer) {
        this.$refs.customerSelect.$refs.baseSelect.removeElement(
          this.filters.customer
        );
      }
      this.filters = {
        supplier: "",
        customer: "",
        status: "",
        from_date: "",
        to_date: "",
        reference_number: "",
        delivery_note_number: "",
        request_level: "",
        supplier_receiver: "",
        funder_receiver: "",
        settlement: ""
      };

      this.$nextTick(() => {
        this.filtersApplied = false;
      });
    },
    toggleFilter() {
      if (this.showFilters && this.filtersApplied) {
        this.clearFilter();
        this.refreshTable();
      }

      this.showFilters = !this.showFilters;
    },
    onSelectCustomer(customer) {
      this.filters.customer = customer;
    },
    async removeInvoice(id) {
      this.id = id;
      swal({
        title: this.$t("general.are_you_sure"),
        text: this.$tc("invoices.confirm_delete"),
        icon: "/assets/icon/trash-solid.svg",
        buttons: true,
        dangerMode: true
      }).then(async value => {
        if (value) {
          let res = await this.deleteInvoice(this.id);

          if (res.data.success) {
            window.toastr["success"](this.$tc("invoices.deleted_message"));
            this.$refs.table.refresh();
            return true;
          }

          if (res.data.error === "payment_attached") {
            window.toastr["error"](
              this.$t("invoices.payment_attached_message"),
              this.$t("general.action_failed")
            );
            return true;
          }

          window.toastr["error"](res.data.error);
          return true;
        }

        this.$refs.table.refresh();
        this.filtersApplied = false;
        this.resetSelectedInvoices();
      });
    },
    async makeMultipleBulkProcessSuper(process_type) {
      if (process_type == "Verified") {
        this.openModal({
          title: "Bulk Processing",
          componentName: "InvoicesRequestStatusChange"
        });
      } else if (process_type == "SendToFunder") {
        this.openModal({
          title: "Bulk Processing",
          componentName: "InvoicesSendToFunder"
        });
      }
    },
    async makeMultipleBulkProcess(process_type) {
      if (this.filters.supplier.company_id || this.filters.customer.id) {
        if (process_type == "Pre-payment") {
          swal({
            title: this.$t("general.are_you_sure"),
            text: this.$tc("invoices.bulk_process_invoices"),
            icon: "/assets/icon/paper-plane-solid.svg",
            buttons: true,
            dangerMode: true
          }).then(async value => {
            if (value) {
              this.setIsSearching();
              let res = await this.bulkProcessPrePaymentInvoices("Pre-payment");
              this.setIsSearching();
              if (res.data.success === true) {
                this.$refs.table.refresh();
                this.filtersApplied = false;
                this.resetSelectedInvoices();
                window.toastr["success"](this.$t("payments.created_message"));
              } else if (res.data.success === false) {
                window.toastr["error"](res.data.error);
              } else {
                window.toastr["error"](res.data.message);
              }
            }
          });
        } else if (process_type == "Prepaid") {
          swal({
            title: this.$t("general.are_you_sure"),
            text: this.$tc("invoices.bulk_process_invoices_settled"),
            icon: "/assets/icon/paper-plane-solid.svg",
            buttons: true,
            dangerMode: true
          }).then(async value => {
            if (value) {
              this.setIsSearching();
              let res = await this.bulkProcessPrePaymentInvoices("Prepaid");
              this.setIsSearching();
              if (res.data.success === true) {
                this.$refs.table.refresh();
                this.filtersApplied = false;
                this.resetSelectedInvoices();
                window.toastr["success"](this.$t("payments.created_message"));
              } else if (res.data.success === false) {
                window.toastr["error"](res.data.error);
              } else {
                window.toastr["error"](res.data.message);
              }
            }
          });
        } else if (process_type == "Eligible") {
          this.openModal({
            title: "Bulk Processing",
            componentName: "InvoicesBulkRequestModal"
          });
        } else if (process_type == "Financed") {
          swal({
            title: this.$t("general.are_you_sure"),
            text: this.$tc("invoices.supplier_requested_invoices_financed"),
            icon: "/assets/icon/paper-plane-solid.svg",
            buttons: true,
            dangerMode: true
          }).then(async value => {
            if (value) {
              var dataList = {
                ids: this.selectedInvoices,
                request_level: "Financed"
              };
              this.setIsSearching();
              let res = await this.bulkProcessRequestedInvoicesWithData(
                dataList
              );
              this.setIsSearching();
              if (res.data.success === true) {
                this.$refs.table.refresh();
                this.filtersApplied = false;
                this.resetSelectedInvoices();
                window.toastr["success"](
                  this.$t("prepayments.prepayment_request_send_message")
                );
              } else if (res.data.success === false) {
                window.toastr["error"](res.data.error);
              } else {
                window.toastr["error"](res.data.message);
              }
            }
          });
        } else {
          this.openModal({
            title: "Bulk Processing",
            componentName: "InvoicesBulkProcessingModal"
          });
        }
      } else {
        if (this.userType == "funder") {
          swal("Alert!", "Supplier must be selected!");
        } else if (this.userType == "supplier") {
          swal("Alert!", "Buyer must be selected!");
        }
      }
    },

    async makeMultipleInvoicePayment() {
      swal({
        title: this.$t("general.are_you_sure"),
        text: this.$tc("invoices.confirm_payment", 2),
        icon: "/assets/icon/file-alt-solid.svg",
        buttons: true,
        dangerMode: true
      }).then(async value => {
        if (value) {
          this.setIsSearching();
          let res = await this.paymentMultipleInvoices();
          this.setIsSearching();
          if (res.data.success === true) {
            this.$refs.table.refresh();
            this.filtersApplied = false;
            this.resetSelectedInvoices();
            window.toastr["success"](this.$t("invoices.payment_message"));
          } else if (res.data.success === false) {
            window.toastr["error"](res.data.error);
          }
        }
      });
    },
    async clearCustomerSearch(removedOption, id) {
      this.filters.customer = "";
      this.refreshTable();
    },
    async clearStatusSearch(removedOption, id) {
      this.filters.status = "";
      this.refreshTable();
    },
    async clearRequestLevelSearch(removedOption, id) {
      this.filters.request_level = "";
      this.refreshTable();
    },
    nomailAmount(row) {
      let subTotal = row.sub_total;
      let nomailAmount = 0;
      let taxes = null;
      if (row.taxes) {
        taxes = row.taxes.filter(function(obj) {
          return obj.operator !== "Subtract";
        });
        if (taxes.length > 0) {
          nomailAmount =
            subTotal +
            taxes
              .map(o => o.amount)
              .reduce((a, c) => {
                return a + c;
              });
        } else {
          nomailAmount = row.sub_total;
        }
      }
      return nomailAmount;
    },
    async ImportPaymentFile() {
      this.openModal({
        title: "Import Payment File",
        componentName: "ImportPaymentPreapprovedInvoiceFileModal"
      });
    },
    async ImportInvoiceFile() {
      this.openModal({
        title: "Import Invoice File",
        componentName: "ImportPreapprovedInvoiceFile"
      });
    },
    async blockedInvoicefunction(id) {
      swal({
        title: this.$t("general.are_you_sure"),
        text: this.$t("invoices.confirm_blocked"),
        icon: "warning",
        buttons: true,
        dangerMode: true
      }).then(async value => {
        if (value) {
          const data = {
            invoice_id: id
          };
          let response = await this.blockedInvoice(data);
          this.refreshTable();
          if (response.data.success) {
            window.toastr["success"](
              this.$tc("invoices.blocked_invoice_successfully")
            );
            return true;
          }
        }
      });
    },
    async unblockedInvoicefunction(id) {
      swal({
        title: this.$t("general.are_you_sure"),
        text: this.$t("invoices.confirm_unblocked"),
        icon: "warning",
        buttons: true,
        dangerMode: true
      }).then(async value => {
        if (value) {
          const data = {
            invoice_id: id
          };
          let response = await this.unblockedInvoice(data);
          this.refreshTable();
          if (response.data.success) {
            window.toastr["success"](
              this.$tc("invoices.unblocked_invoice_successfully")
            );
            return true;
          }
        }
      });
    },
    async rejectedInvoicefunction(id) {
      swal({
        title: this.$t("general.are_you_sure"),
        text: this.$t("invoices.confirmed_rejected"),
        icon: "warning",
        buttons: true,
        dangerMode: true
      }).then(async value => {
        if (value) {
          const data = {
            invoice_id: id
          };
          let response = await this.rejectedInvoice(data);
          this.refreshTable();
          if (response.data.success) {
            window.toastr["success"](
              this.$tc("invoices.rejected_invoice_successfully")
            );
            return true;
          }
        }
      });
    }
  }
};
</script>
